// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"ze","contentFrame":"zf","buttonGroup":"zh","button":"zi","header":"zj","text":"zk","contentImage":"zl","closeButton":"zm"};